import {Button, styled} from "@mui/material";
import {HoverElevationButton} from "./base-buttons";

export const DefaultNewOrderSelectedButton = styled(Button)(({theme}) => ({
    backgroundColor: theme.barekam.additionalService.button.selected,
    color: '#FFF',

    height: '2.5rem',
    width: '2.25rem',
    borderRadius: '2.25rem',

    '&:hover': {
        background: theme.barekam.additionalService.button.selected,
    }
}));

export const NewOrderChooseButton = styled(DefaultNewOrderSelectedButton)(({theme}) => ({
    backgroundColor: theme.barekam.additionalService.button.default,
    width: 'auto',

    '&:hover': {
        background: theme.barekam.additionalService.button.hover,
    }
}));

export const NewOrderProceedButton = styled(HoverElevationButton)(({theme}) => ({
    backgroundColor: theme.barekam.additionalService.button.proceed,
    color: '#FFF',
    padding: '0.5rem 1.5rem',
    '&:hover': {
        background: theme.barekam.additionalService.button.proceed,
    }
}));
